import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ArrowRightSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowRightSmallIconPath";
import { useTranslation } from "@coworker/locales";
import { ComponentNotificationBodyAssignedOptionCount } from "@fixa/notifications";
import styles from "../task-notification.module.css";
import { getBodyAssignerString } from "../utils/task-notification-body";

interface TaskNotificationBodyAssignedOptionCountProps extends ComponentNotificationBodyAssignedOptionCount {
  read: boolean;
}
const TaskNotificationBodyAssignedOptionCount = ({
  props: { optionCountInfo, oldAssignedTo, newAssignedTo },
}: TaskNotificationBodyAssignedOptionCountProps) => {
  const { t } = useTranslation();
  const { label, count } = optionCountInfo;
  const oldAssignedToString = getBodyAssignerString(oldAssignedTo);
  const newAssignedToString = getBodyAssignerString(newAssignedTo);
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {!!oldAssignedToString && !!newAssignedToString && (
          <div>
            <span
              className={
                styles["task-notification-item-body-old-assigned"] ?? ""
              }
            >
              {oldAssignedToString}
            </span>
            <FixaSSRIcon paths={ArrowRightSmallIconPath} />
            <span>{newAssignedToString}</span>
          </div>
        )}
        {!!label && <div>{t(label, { count })}</div>}
      </div>
    </div>
  );
};

export default TaskNotificationBodyAssignedOptionCount;
